module.exports = __webpack_public_path__ + "static/media/pide_back.49c903ff.jpg";